import { createFileRoute } from '@tanstack/react-router';

import { SelectEmailPanel } from '../-components/empty-states';

export const Route = createFileRoute('/_dashboard/mailbox/sent/')({
  component: SelectEmailPanel,
});
